<template>
	<div class="home-page" @click="closeAllBox" @contextmenu="closeAllBox">
		<div class="app-container" :class="{ fullscreen: configStore.fullScreen }">
			<div class="navi-bar">
				<div class="navi-bar-box">
					<div class="top">
						<div class="avater" @click="showUserProfile">
							<head-image :name="mine.nickName" :size="42" :url="mine.headImageThumb">
							</head-image>
						</div>
						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'">
								<div class="menu-item">
									<span class="icon iconfont icon-chat"></span>
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'">
								<div class="menu-item">
									<span class="icon iconfont icon-friend"></span>
									<div v-show="recvCount > 0" class="unread-text">{{ recvCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/group'">
								<div class="menu-item">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/setting'">
								<div class="menu-item">
									<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
								</div>
							</router-link>
						</div>
					</div>

					<div class="bottom">
						<div v-if="!configStore.electronMode" class="bottom-item" @click="onSwtichFullScreen">
							<i class="el-icon-full-screen"></i>
						</div>
						<div class="bottom-item" @click="onExit()" :title="$t('home.logout')">
							<span class="icon iconfont icon-exit"></span>
						</div>
					</div>
				</div>
			</div>
			<div class="content-box">
				<router-view></router-view>
			</div>
			<user-info ref="userInfo"></user-info>
			<group-info ref="groupInfo"></group-info>
			<full-image ref="fullImage"></full-image>
			<preview-file ref="previewFile"></preview-file>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
			<user-profile-card ref="userProfileCard"></user-profile-card>
		</div>
	</div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import UserInfo from '../components/common/UserInfo.vue';
import GroupInfo from '../components/group/GroupInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import UserProfileCard from '../components/common/UserProfileCard.vue';
import PreviewFile from '../components/common/PreviewFile.vue';
import { clearLoginSession } from '../api/auth.js';

export default {
	components: {
		HeadImage,
		UserInfo,
		GroupInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo,
		UserProfileCard,
		PreviewFile
	},
	data() {
		return {
			audio: false,
			lastPlayAudioTime: new Date().getTime() - 1000,
			reconnecting: false,
			notification: null,
			privateMessagesBuffer: [],
			groupMessagesBuffer: [],
			systemMessagesBuffer: []
		}
	},
	methods: {
		init() {
			this.$eventBus.$on('exit', () => {
				// 退出登陆
				this.onExit();
			});
			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话
				this.$nextTick(() => this.$refs.rtcPrivateVideo.open(rctInfo));
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话
				this.$nextTick(() => this.$refs.rtcGroupVideo.open(rctInfo));
			});
			this.$eventBus.$on('openUserInfo', (user, pos) => {
				// 打开用户卡片
				this.$nextTick(() => this.$refs.userInfo.open(user, pos));
			});
			this.$eventBus.$on('openGroupInfo', (group, token, pos) => {
				// 打开群卡片
				this.$nextTick(() => this.$refs.groupInfo.open(group, token, pos));
			});
			this.$eventBus.$on('openFullImage', url => {
				// 图片大图
				this.$nextTick(() => this.$refs.fullImage.open(url));
			});
			this.$eventBus.$on('openPreviewFile', url => {
				// 文件预览
				this.$nextTick(() => this.$refs.previewFile.open(url));
			});
			this.loadStore().then(() => {
				// ws初始化
				this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
				this.$wsApi.onConnect(() => {
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						// 加载离线消息
						this.pullOfflineMessage();
					}
				});
				this.$wsApi.onMessage((cmd, message) => {
					if (cmd == 2) {
						// 关闭ws
						this.$wsApi.close(3000)
						// 异地登录，强制下线
						this.$alert(this.$t('home.forceLogout'), this.$t('home.forceLogoutTitle'), {
							confirmButtonText: this.$t('common.ok'),
							callback: action => {
								this.onExit();
							}
						});
					} else if (cmd == 3) {
						if (this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							this.privateMessagesBuffer.push(message);
						} else {
							// 插入私聊消息
							this.handlePrivateMessage(message);
						}
					} else if (cmd == 4) {
						if (this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							console.log("消息进入缓存区:", message)
							this.groupMessagesBuffer.push(message);
						} else {
							// 插入群聊消息
							this.handleGroupMessage(message);
						}
					} else if (cmd == 5) {
						if (this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							this.systemMessagesBuffer.push(message);
						} else {
							// 处理系统消息
							this.handleSystemMessage(message);
						}
					}
				});
				this.$wsApi.onClose(e => {
					console.log(e);
					if (e.code != 3000) {
						// 断线重连
						this.reconnectWs();
					}
				});
			}).catch(e => {
				console.log(e)
				this.$message.error(this.$t('home.initFailed'));
				this.onExit();
			})
		},
		reconnectWs() {
			// 记录标志
			this.reconnecting = true;
			// 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
			this.userStore.loadUser().then(() => {
				// 断线重连
				this.$message.error(this.$t('home.reconnecting'));
				this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(
					"accessToken"));
			}).catch(() => {
				// 10s后重试
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			// 重连成功
			this.reconnecting = false;
			// 重新加载群和好友
			const promises = [];
			promises.push(this.friendStore.pullFriends());
			promises.push(this.groupStore.pullGroups());
			Promise.all(promises).then(() => {
				// 拉取离线消息
				this.pullOfflineMessage();
				// 刷新好友在线状态
				this.friendStore.refreshOnline();
				// 拉取好友请求
				this.friendStore.loadRequest();
				this.$message.success(this.$t('home.reconnectSuccess'));
			}).catch(() => {
				this.$message.error(this.$t('home.initFailed'));
				this.onExit();
			})
		},
		async loadStore() {
			await this.userStore.loadUser();
			await this.$db.open(this.userStore.userInfo.id);
			// 加载好友要在加载会话前面，否则好友在线状态不显示
			await this.friendStore.loadFriend();
			const promises = [];
			promises.push(this.groupStore.loadGroup());
			promises.push(this.configStore.loadConfig());
			promises.push(this.chatStore.loadConversations());
			return Promise.all(promises);
		},
		unloadStore() {
			this.friendStore.clear();
			this.groupStore.clear();
			this.chatStore.clear();
			this.userStore.clear();
		},
		pullOfflineMessage() {
			let timeStamp = new Date().getTime();
			this.chatStore.setLoading(true);
			const promises = [];
			const maxPrivateMessageId = this.chatStore.findMaxMessageId(this.$enums.CONVERSATION_TYPE.PRIVATE);
			const maxGroupMessageId = this.chatStore.findMaxMessageId(this.$enums.CONVERSATION_TYPE.GROUP);
			const MaxSeqNo = this.chatStore.findMaxSeqNo(this.$enums.CONVERSATION_TYPE.SYSTEM);
			promises.push(this.pullPrivateOfflineMessage(maxPrivateMessageId));
			promises.push(this.pullGroupOfflineMessage(maxGroupMessageId));
			promises.push(this.pullSystemOfflineMessage(MaxSeqNo));
			Promise.all(promises).then(async (messages) => {
				console.log("加载离线消息耗时1:", new Date().getTime() - timeStamp)
				// 处理离线消息
				await this.handlePrivateOfflineMessage(messages[0]);
				await this.handleGroupOfflineMessage(messages[1]);
				await this.handleSystemOfflineMessage(messages[2]);
				console.log("加载离线消息耗时3:", new Date().getTime() - timeStamp)
				// 处理缓冲区收到的实时消息
				for (const m of this.privateMessagesBuffer) {
					await this.handlePrivateMessage(m);
				}
				for (const m of this.groupMessagesBuffer) {
					await this.handleGroupMessage(m);
				}
				for (const m of this.systemMessagesBuffer) {
					await this.handleSystemMessage(m);
				}
				// 清空缓冲区
				this.privateMessagesBuffer = [];
				this.groupMessagesBuffer = [];
				this.systemMessagesBuffer = [];
				// 关闭加载离线标记
				this.chatStore.setLoading(false);
				// 打印耗时
				let size = messages[0].length + messages[1].length + messages[2].length;
				let time = new Date().getTime() - timeStamp;
				console.log("加载离线消息耗时:", time, ",消息数量:", size)
			}).catch((e) => {
				console.log(e)
				this.$message.error(this.$t('home.pullMsgFailed'));
				this.onExit();
			})
		},
		async handlePrivateOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			// 会话信息
			const conversationMap = new Map();
			// 离线消息,map结构方便查询
			const messageMap = new Map(messages.map(m => [m.id, m]));
			// 处理过程中衍生的需要入库的事消息
			const tmpMessages = [];
			for (const m of messages) {
				// 标记这条消息是不是自己发的
				m.selfSend = m.sendId == this.mine.id;
				// 好友id
				const friendId = m.selfSend ? m.recvId : m.sendId;
				// 标记消息所属会话id
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friendId);
				m.convKey = convKey;
				// 查询会话
				let conversation = conversationMap.get(friendId);
				if (!conversation) {
					// 查db
					conversation = await this.$db.findConversationByKey(convKey);
					if (!conversation) {
						// 创建新会话
						const friend = this.loadFriendInfo(friendId);
						conversation = {
							key: convKey,
							type: this.$enums.CONVERSATION_TYPE.PRIVATE,
							targetId: friend.id,
							showName: friend.showNickName,
							headImage: friend.headImage,
							companyName: friend.companyName,
							isDnd: friend.isDnd,
							isTop: friend.isTop,
							lastContent: "",
							lastSendTime: new Date().getTime(),
							optTime: new Date().getTime(),
							unreadCount: 0,
							lastTimeTip: 0,
							maxMessageId: 0,
							minSeqNo: 0,
							maxSeqNo: 0,
							maxReadedId: 0
						}
					}
					conversationMap.set(friendId, conversation);
				}
				// 会话时间	
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				// 记录会话最大消息id
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id)
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				// 会话未读加1
				if (!m.selfSend && m.status != this.$enums.MESSAGE_STATUS.READED &&
					m.status != this.$enums.MESSAGE_STATUS.RECALL && m.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
					conversation.unreadCount++;
				}
				// 撤回消息
				if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
					const recallMessageId = Number(JSON.parse(m.content).id);
					const recallMessageTip = JSON.parse(m.content).tip || '';
					let recallMessage = messageMap.get(recallMessageId);
					if (!recallMessage) {
						recallMessage = await this.$db.findMessageById(recallMessageId);
						if (!recallMessage) {
							continue;
						}
						tmpMessages.push(recallMessage);
					}
					// 把原消息改造成一条提示消息
					recallMessage.status = this.$enums.MESSAGE_STATUS.PENDING;
					recallMessage.content = recallMessageTip;
					recallMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
					// 会话提示语
					conversation.lastContent = this.$msgUtil.previewContent(recallMessage);
					conversation.sendNickName = "";
					// 如果撤回的消息不在本次拉取的离线消息中，则有可能本地库也有消息引用了这条消息
					if (!messageMap.has(recallMessageId)) {
						const quoteMessages = await this.$db.findQuoteMessages(recallMessage);
						// 被引用的消息内容改成"引用的消息已撤回"
						quoteMessages.forEach((m1) => {
							m1.quoteMessage.content = JSON.stringify({ key: 'tip.recall.quote' });
							m1.quoteMessage.status = this.$enums.MESSAGE_STATUS.RECALL;
							m1.quoteMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
						})
						tmpMessages.push(...quoteMessages);
					}
				} else {
					// 会话列表内容
					conversation.lastContent = this.$msgUtil.previewContent(m);
				}
			}
			// 批量保存会话和消息
			const conversations = Array.from(conversationMap.values());
			await this.$db.saveConversationAndMessage(conversations, messages.concat(tmpMessages));
			this.chatStore.append(conversations);
		},
		async handleGroupOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			// 会话信息
			const conversationMap = new Map();
			// 离线消息,map结构方便查询
			const messageMap = new Map(messages.map(m => [m.id, m]));
			// 处理过程中衍生的需要入库的事消息
			const tmpMessages = [];
			for (const m of messages) {
				// 标记这条消息是不是自己发的
				m.selfSend = m.sendId == this.mine.id;
				// 好友id
				const groupId = m.groupId;
				// 标记消息所属会话id
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, groupId);
				m.convKey = convKey;
				// 查询会话
				let conversation = conversationMap.get(groupId);
				if (!conversation) {
					// 查db
					conversation = await this.$db.findConversationByKey(convKey);
					if (!conversation) {
						// 创建新会话
						const group = this.loadGroupInfo(groupId);
						conversation = {
							key: convKey,
							type: this.$enums.CONVERSATION_TYPE.GROUP,
							targetId: group.id,
							showName: group.showGroupName,
							headImage: group.headImageThumb,
							isDnd: group.isDnd,
							isTop: group.isTop,
							lastContent: "",
							lastSendTime: new Date().getTime(),
							optTime: new Date().getTime(),
							unreadCount: 0,
							atMe: false,
							atAll: false,
							lastAtMessageId: -1,
							lastTimeTip: 0,
							maxMessageId: 0,
							minSeqNo: 0,
							maxSeqNo: 0,
							maxReadedId: 0
						}
					}
					conversationMap.set(groupId, conversation);
				}
				// 会话时间	
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				// 记录会话最大消息id
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id);
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				// 会话未读加1
				if (!m.selfSend && m.status != this.$enums.MESSAGE_STATUS.READED &&
					m.status != this.$enums.MESSAGE_STATUS.RECALL && m.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
					conversation.unreadCount++;
				}
				// 是否有人@我
				if (!m.selfSend && m.atUserIds && m.status != this.$enums.MESSAGE_STATUS.READED) {
					const userId = this.mine.id;
					if (m.atUserIds.indexOf(userId) >= 0) {
						conversation.atMe = true;
						conversation.lastAtMessageId = m.id;
					}
					if (m.atUserIds.indexOf(-1) >= 0) {
						conversation.atAll = true;
						conversation.lastAtMessageId = m.id;
					}
				}
				// 撤回消息
				if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
					const recallMessageId = Number(JSON.parse(m.content).id);
					const recallMessageTip = JSON.parse(m.content).tip || '';
					let recallMessage = messageMap.get(recallMessageId);
					if (!recallMessage) {
						recallMessage = await this.$db.findMessageById(recallMessageId);
						if (!recallMessage) {
							continue;
						}
						tmpMessages.push(recallMessage);
					}
					// 改造成一条提示消息
					recallMessage.status = this.$enums.MESSAGE_STATUS.PENDING;
					recallMessage.content = recallMessageTip;
					recallMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
					// 会话提示语
					conversation.lastContent = this.$msgUtil.previewContent(recallMessage);
					conversation.sendNickName = "";
					// 如果撤回的消息不在本次拉取的离线消息中，则有可能本地库也有消息引用了这条消息
					if (!messageMap.has(recallMessageId)) {
						const quoteMessages = await this.$db.findQuoteMessages(recallMessage);
						// 被引用的消息内容改成"引用的消息已撤回"
						quoteMessages.forEach((m1) => {
							m1.quoteMessage.content = JSON.stringify({ key: 'tip.recall.quote' });
							m1.quoteMessage.status = this.$enums.MESSAGE_STATUS.RECALL;
							m1.quoteMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
						})
						tmpMessages.push(...quoteMessages);
					}
				} else {
					// 会话列表内容
					conversation.lastContent = this.$msgUtil.previewContent(m);
					// 其他成员发的消息显示发送昵称
					conversation.sendNickName = m.selfSend ? '' : m.sendNickName;
				}
			}
			const conversations = Array.from(conversationMap.values());
			await this.$db.saveConversationAndMessage(conversations, messages.concat(tmpMessages));
			this.chatStore.append(conversations);
		},
		async handleSystemOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.SYSTEM, 0);
			// 查db
			let conversation = await this.$db.findConversationByKey(convKey);
			if (!conversation) {
				// 创建新会话
				const headImage = require('@/assets/image/chat_system.png')
				conversation = {
					key: convKey,
					type: this.$enums.CONVERSATION_TYPE.SYSTEM,
					targetId: 0,
					showName: this.$t('home.systemNotify'),
					headImage: headImage,
					isDnd: false,
					isTop: false,
					lastContent: "",
					lastSendTime: new Date().getTime(),
					optTime: new Date().getTime(),
					unreadCount: 0,
					lastTimeTip: 0,
					maxMessageId: 0,
					minSeqNo: 0,
					maxSeqNo: 0,
					maxReadedId: 0
				}
			}
			for (const m of messages) {
				// 系统消息没有业务id,直接在这里生成
				m.localId = this.$nextSnowflakeId();
				// 标记消息所属会话id
				m.convKey = convKey;
				// 会话列表内容
				conversation.lastContent = this.$msgUtil.previewContent(m);
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				// 记录会话最大消息序号
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id);
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				// 会话未读加1
				if (m.status != this.$enums.MESSAGE_STATUS.READED) {
					conversation.unreadCount++;
				}
			}
			// 批量保存会话和消息
			const conversations = [conversation];
			await this.$db.saveConversationAndMessage(conversations, messages);
			this.chatStore.append(conversations);
		},
		pullPrivateOfflineMessage(minId) {
			return this.$http({
				url: "/message/private/loadOfflineMessage?minId=" + minId,
				method: 'GET'
			})
		},
		pullGroupOfflineMessage(minId) {
			return this.$http({
				url: "/message/group/loadOfflineMessage?minId=" + minId,
				method: 'GET'
			})
		},
		pullSystemOfflineMessage(minSeqNo) {
			return this.$http({
				url: "/message/system/loadOfflineMessage?minSeqNo=" + minSeqNo,
				method: 'GET'
			})
		},
		async handlePrivateMessage(m) {
			// 标记这条消息是不是自己发的
			m.selfSend = m.sendId == this.mine.id;
			// 好友id
			const friendId = m.selfSend ? m.recvId : m.sendId;
			// 会话信息
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friendId);
			// 消息已读处理，清空已读数量
			if (m.type == this.$enums.MESSAGE_TYPE.READED) {
				await this.chatStore.resetUnreadCount(convKey)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (m.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				await this.chatStore.readedMessage(convKey)
				return;
			}
			// 消息撤回
			if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
				await this.chatStore.recallMessage(convKey, m)
				return;
			}
			// 好友申请
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPLY) {
				this.friendStore.addRequest(JSON.parse(m.content))
				return;
			}
			// 好友申请被同意、拒绝、撤回
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPROVE
				|| m.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_REJECT
				|| module.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_RECALL) {
				this.friendStore.removeRequest(JSON.parse(m.content).id)
				return;
			}
			// 新增好友
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.friendStore.addFriend(JSON.parse(m.content));
				return;
			}
			// 删除好友
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.friendStore.removeFriend(friendId);
				return;
			}
			// 好友在线状态
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
				this.friendStore.updateOnlineStatus(JSON.parse(m.content));
				return;
			}
			// 对好友设置免打扰
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
				this.friendStore.setDnd(friendId, JSON.parse(m.content));
				await this.chatStore.setDnd(convKey, JSON.parse(m.content));
				return;
			}
			// 对好友进行会话置顶
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_TOP) {
				this.friendStore.setTop(friendId, JSON.parse(m.content));
				await this.chatStore.setTop(convKey, JSON.parse(m.content));
				return;
			}
			// 单人webrtc 信令
			if (this.$msgType.isRtcPrivate(m.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(m)
				return;
			}
			// 消息插入
			if (this.$msgType.isNormal(m.type) || this.$msgType.isTip(m.type) || this.$msgType.isAction(m.type)) {
				const friend = this.loadFriendInfo(friendId);
				await this.insertPrivateMessage(friend, m);
			}
		},
		async insertPrivateMessage(friend, m) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id);
			const chatInfo = {
				type: this.$enums.CONVERSATION_TYPE.PRIVATE,
				targetId: friend.id,
				showName: friend.showNickName,
				headImage: friend.headImage,
				companyName: friend.companyName,
				isDnd: friend.isDnd,
				isTop: friend.isTop
			};
			// 打开会话
			await this.chatStore.openChat(chatInfo);
			// 插入消息
			await this.chatStore.insertMessage(convKey, m);
			// 通知chat-box组件
			if (this.chatStore.isActive(convKey)) {
				this.$eventBus.$emit("newMessage", m);
			}
			if (!friend.isDnd && !m.selfSend && this.$msgType.isNormal(m.type)
				&& m.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 消息提醒
				const conv = this.chatStore.conversationMap.get(convKey);
				this.showNotification(conv, friend.showNickName, friend.headImage)
			}
		},
		async handleGroupMessage(m) {
			// 标记这条消息是不是自己发的
			m.selfSend = m.sendId == this.mine.id;
			// 会话信息
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, m.groupId);
			// 发送用户昵称优先显示好友备注的名字
			if (m.sendId && m.sendNickName) {
				const f = this.friendStore.findFriend(m.sendId);
				if (f && !f.deleted && f.remarkNickName) {
					m.sendNickName = f.remarkNickName;
				}
			}
			// 消息已读处理
			if (m.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				await this.chatStore.resetUnreadCount(convKey)
				await this.chatStore.resetAtMessage(convKey)
				return;
			}
			// 消息回执处理
			if (m.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				const message = {
					localId: m.localId,
					readedCount: m.readedCount,
					receiptOk: m.receiptOk
				};
				await this.chatStore.updateMessage(convKey, message)
				return;
			}
			// 消息撤回
			if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
				await this.chatStore.recallMessage(convKey, m)
				return;
			}
			// 新增群
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				this.groupStore.addGroup(JSON.parse(m.content));
				return;
			}
			// 删除群
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.groupStore.removeGroup(m.groupId);
				return;
			}
			// 群消息置顶
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_TOP_MESSAGE) {
				const topMessage = m.content ? JSON.parse(m.content) : null;
				this.groupStore.updateTopMessage(m.groupId, topMessage);
				return;
			}
			// 对群设置免打扰
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
				this.groupStore.setDnd(m.groupId, JSON.parse(m.content));
				await this.chatStore.setDnd(convKey, JSON.parse(m.content));
				return;
			}
			// 群全体禁言
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_ALL_MUTED) {
				this.groupStore.setAllMuted(m.groupId, JSON.parse(m.content));
				return;
			}
			// 被禁言
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_MUTED) {
				this.groupStore.setMuted(m.groupId, JSON.parse(m.content));
				return;
			}
			// 对群进行会话置顶
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_TOP) {
				this.groupStore.setTop(m.groupId, JSON.parse(m.content));
				await this.chatStore.setTop(convKey, JSON.parse(m.content));
				return;
			}
			// 群通话信令
			if (this.$msgType.isRtcGroup(m.type)) {
				if (m.type == this.$enums.MESSAGE_TYPE.RTC_GROUP_INFO) {
					// 群通话状态变化
					const rtcInfo = JSON.parse(m.content);
					this.groupStore.setRtcInfo(m.groupId, rtcInfo);
				} else {
					this.$nextTick(() => {
						this.$refs.rtcGroupVideo.onRTCMessage(m);
					})
				}
				return;
			}
			// 插入群聊消息
			if (this.$msgType.isNormal(m.type) || this.$msgType.isTip(m.type) || this.$msgType.isAction(m.type)) {
				const group = this.loadGroupInfo(m.groupId);
				await this.insertGroupMessage(group, m);
			}
		},
		async insertGroupMessage(group, m) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id);
			const chatInfo = {
				type: this.$enums.CONVERSATION_TYPE.GROUP,
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb,
				isDnd: group.isDnd,
				isTop: group.isTop
			};
			// 打开会话
			await this.chatStore.openChat(chatInfo);
			// 插入消息
			await this.chatStore.insertMessage(convKey, m);
			// 通知chat-box组件
			if (this.chatStore.isActive(convKey)) {
				this.$eventBus.$emit("newMessage", m);
			}
			// 提示音和消息提醒
			if (!group.isDnd && !m.selfSend && !this.chatStore.loading && this.$msgType.isNormal(m.type)
				&& m.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 消息提醒
				const conv = this.chatStore.conversationMap.get(convKey);
				this.showNotification(conv, group.showGroupName, group.headImageThumb)
			}
		},
		async handleSystemMessage(m) {
			// 消息已读处理，清空已读数量
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.SYSTEM, 0)
			if (m.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount(convKey)
				return;
			}
			// 用户被封禁
			if (m.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert(this.$t('home.accountBannedReason', { reason: m.content }), this.$t('home.accountBannedTitle'), {
					confirmButtonText: this.$t('common.ok'),
					callback: () => {
						this.onExit();
					}
				});
				return;
			}
			// 用户账户注销
			if (m.type == this.$enums.MESSAGE_TYPE.USER_UNREG) {
				this.$wsApi.close(3000);
				this.$alert(this.$t('home.accountCancelled'), {
					confirmButtonText: this.$t('common.ok'),
					callback: () => {
						this.onExit();
					}
				});
				return;
			}
			// 插入消息
			await this.insertSystemMessage(m);
		},
		async insertSystemMessage(m) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.SYSTEM, 0);
			const headImage = require('@/assets/image/chat_system.png')
			const chatInfo = {
				key: convKey,
				type: this.$enums.CONVERSATION_TYPE.SYSTEM,
				targetId: 0,
				showName: this.$t('home.systemNotify'),
				headImage: headImage
			};
			// 打开会话
			await this.chatStore.openChat(chatInfo);
			// 插入消息
			await this.chatStore.insertMessage(convKey, m);
		},
		onSwtichFullScreen() {
			this.configStore.setFullScreen(!this.configStore.fullScreen);
		},
		onExit() {
			this.unloadStore();
			this.$wsApi.close(3000);
			clearLoginSession(true);
			this.$elm.setTitleTip("");
			this.$db.close();
			this.$router.push("/login");
		},
		closeAllBox() {
			this.$refs.groupInfo.close();
			this.$refs.userInfo.close();
		},
		playAudioTip() {
			// 播放间隔必须大于1s
			let interval = new Date().getTime() - this.lastPlayAudioTime;
			if (this.mine.isAudioTip && interval > 1000) {
				if (!this.audio) {
					this.audio = new Audio();
					this.audio.src = require(`@/assets/audio/tip.mp3`);
				}
				this.lastPlayAudioTime = new Date().getTime();
				this.audio.play();
			}
		},
		showNotification(conv, title, icon) {
			// 消息提醒
			if (window.Notification && window.electronAPI) {
				// 当窗口失去焦点，则弹出通知消息
				window.electronAPI.invoke("isFocused").then(foucus => {
					if (!foucus) {
						this.notification && this.notification.close();
						let iconPath = icon ? icon : 'logo.ico';
						this.notification = new Notification(title, {
							body: conv.lastContent,
							icon: iconPath
						})
						// 点击通知消息，激活聊天会话
						this.notification.onclick = () => {
							this.chatStore.openChat(conv);
							this.chatStore.setActiveChat(conv.key);
							this.$router.push("/home/chat");
							// 唤醒在后台的客户端
							window.electronAPI.sendEvent("show");
						}
					}
				})
			}
		},
		loadFriendInfo(id) {
			let friend = this.friendStore.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					showNickName: this.$t('home.unknownUser'),
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.groupStore.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: this.$t('home.unknownGroup'),
					headImageThumb: ""
				}
			}
			return group;
		},
		showUserProfile() {
			this.$refs.userProfileCard.open();
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		unreadCount() {
			let unreadCount = 0;
			const conversations = this.chatStore.conversations;
			conversations.forEach((conv) => {
				if (!conv.isDnd) {
					unreadCount += conv.unreadCount
				}
			})
			return unreadCount;
		},
		recvCount() {
			const requests = this.friendStore.requests;
			return requests.filter((req) => req.recvId == this.mine.id).length;
		}
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? this.$t('home.nUnreadTitle', { n: newCount }) : "";
				this.$elm.setTitleTip(tip);
				// 控制托盘图标闪烁
				if (window.electronAPI) {
					if (newCount > 0) {
						// 有未读消息时，检查窗口是否在焦点
						window.electronAPI.invoke('isFocused').then(foucus => {
							if (!foucus) {
								// 窗口不在焦点时开始闪烁
								window.electronAPI.sendEvent('startTrayBlink');
							}
						});
					} else {
						// 没有未读消息时停止闪烁
						window.electronAPI.sendEvent('stopTrayBlink');
					}
				}
			},
			immediate: true
		}
	},
	mounted() {
		this.$wsApi.close();
		this.init();
		// 修改electron窗口尺寸
		window.electronAPI && window.electronAPI.sendEvent('resize', {
			width: 970,
			height: 660,
			maximizable: true
		})
		window.electronAPI && window.electronAPI.sendEvent('center')
	},
	unmounted() {
		this.$wsApi.close();
	}
}
</script>

<style scoped lang="scss">
.home-page {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	overflow: hidden;
	background: var(--im-color-primary-light-9);

	.app-container {
		width: 62vw;
		height: 80vh;
		display: flex;
		min-height: 660px;
		min-width: 970px;
		position: absolute;
		border-radius: 4px;
		overflow: hidden;
		box-shadow: var(--im-box-shadow-dark);
		transition: 0.2s;

		&.fullscreen {
			transition: 0.2s;
			width: 100vw;
			height: 100vh;
		}
	}

	.navi-bar {
		--icon-font-size: 22px;
		--width: 70px;
		width: var(--width);
		background: linear-gradient(180deg, var(--im-color-primary-light-1) 0%, var(--im-color-primary-light-2) 100%);
		padding-top: 25px;
		position: relative;
		box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

		// 添加顶部装饰线
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 3px;
			background: linear-gradient(90deg, var(--im-color-primary) 0%, var(--im-color-primary-light-3) 50%, var(--im-color-primary) 100%);
		}

		.navi-bar-box {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.bottom {
				margin-bottom: 25px;
			}
		}

		.avater {
			display: flex;
			justify-content: center;
			margin-bottom: 10px;

			// 为头像添加容器样式
			:deep(.head-image) {
				border: 3px solid rgba(255, 255, 255, 0.2);
				border-radius: 50%;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				transition: all 0.3s ease;

				&:hover {
					border-color: rgba(255, 255, 255, 0.4);
					transform: scale(1.05);
					box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
				}
			}
		}

		.menu {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			flex-wrap: wrap;
			margin-top: 25px;
			gap: 8px;

			.link {
				text-decoration: none;
				display: flex;
				justify-content: center;
			}

			.router-link-active .menu-item {
				color: white;
				background: linear-gradient(135deg, var(--im-color-primary-light-2) 0%, var(--im-color-primary) 100%);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
				transform: translateX(2px);

				&::before {
					opacity: 1;
					transform: scale(1);
				}
			}

			.link:not(.router-link-active) .menu-item:hover {
				background: linear-gradient(135deg, var(--im-color-primary) 0%, var(--im-color-primary-light-2) 100%);
				transform: scale(1.08) translateX(2px);
				box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
				color: white;
			}

			.menu-item {
				position: relative;
				color: rgba(255, 255, 255, 0.8);
				width: 50px;
				height: 50px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 10px;
				border-radius: 12px;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				cursor: pointer;

				// 添加左侧指示条
				&::before {
					content: '';
					position: absolute;
					left: -5px;
					width: 3px;
					height: 20px;
					background: white;
					border-radius: 2px;
					opacity: 0;
					transition: all 0.3s ease;
				}

				.icon {
					font-size: var(--icon-font-size);
					transition: all 0.3s ease;
				}

				.unread-text {
					position: absolute;
					background: var(--im-color-danger);
					left: 32px;
					top: 3px;
					color: white;
					border-radius: 10px;
					padding: 1px 6px;
					font-size: 10px;
					font-weight: 600;
					text-align: center;
					white-space: nowrap;
					border: 1px solid rgba(255, 255, 255, 0.9);
					box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
					min-width: 16px;
					height: 16px;
					display: flex;
					align-items: center;
					justify-content: center;
					z-index: 1;
				}
			}
		}

		.bottom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 45px;
			width: 100%;
			cursor: pointer;
			color: rgba(255, 255, 255, 0.7);
			font-size: var(--icon-font-size);
			border-radius: 8px;
			margin: 4px 0;
			transition: all 0.3s ease;
			position: relative;

			.icon {
				font-size: var(--icon-font-size);
				transition: all 0.3s ease;
			}

			&:hover {
				color: white;
				background: rgba(255, 255, 255, 0.1);
				transform: scale(1.05);

				.icon {
					transform: scale(1.1);
				}
			}

			&:active {
				transform: scale(0.95);
			}
		}
	}

	.content-box {
		flex: 1;
		padding: 0;
		background: var(--im-background);
		text-align: center;
	}
}
</style>
